import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { Milestone } from '../../types'
import { milestoneService } from '../../services/milestoneService'
import planService from '../../services/planService'


interface MilestonesState {
  milestones: Milestone[]
  loading: boolean
  error: string | null
}

const initialState: MilestonesState = {
  milestones: [],
  loading: false,
  error: null,
}

// Async thunks
export const fetchMilestones = createAsyncThunk(
  'milestones/fetchMilestones',
  async (Id: string) => {
    const response = await planService.getMilestonesByPlan(Id);
    return response
  }
)

export const updateMilestoneStatus = createAsyncThunk(
  'milestones/updateMilestoneStatus',
  async (params: { milestoneId: string; status: string }) => {
    const response = await milestoneService.updateMilestoneStatus(params)
    return response
  }
)

const milestonesSlice = createSlice({
  name: 'milestones',
  initialState,
  reducers: {
    clearMilestones: (state) => {
      state.milestones = []
    },
    clearError: (state) => {
      state.error = null
    },
    updateMilestone: (state, action: PayloadAction<Milestone>) => {
      const index = state.milestones.findIndex(m => m.milestoneId === action.payload.milestoneId)
      if (index !== -1) {
        state.milestones[index] = action.payload
      }
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch milestones
      .addCase(fetchMilestones.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMilestones.fulfilled, (state, action) => {
        state.loading = false
        state.milestones = action.payload.data
      })
      .addCase(fetchMilestones.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to fetch milestones'
      })
      // Update milestone status
      .addCase(updateMilestoneStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateMilestoneStatus.fulfilled, (state, action) => {
        state.loading = false
        const index = state.milestones.findIndex(m => m.milestoneId === action.payload.data.milestoneId)
        if (index !== -1) {
          state.milestones[index] = action.payload.data
        }
      })
      .addCase(updateMilestoneStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Failed to update milestone status'
      })
  },
})

export const { clearMilestones, clearError, updateMilestone } = milestonesSlice.actions
export default milestonesSlice.reducer